import { CatEstatusService } from './../../servicios/cat-estatus.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { CargosDetallesService } from "../../servicios/cargos-detalles.service";
import { AguasService } from "../../servicios/aguas.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { CargosDetalles, IngresoPor, CatUsuarios, Descuentos, RegistroBitacoraInput, CargosDetallesRequest, AuxJasper, ParametroJasper, Aguas, PadObservaciones, Parametros, CatTipoGiros } from "../../entidades/entidades";
import { CargosDetallesInput } from "../../entidades/entidades";
import { SelectItem } from 'primeng/api';
import { MuestraImageneservice } from "../../servicios/muestra-imagenes.service";
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { PadObservacionesService } from "../../servicios/pad-observaciones.service";
import { AuthenticationService } from "app/servicios";
import { ParametrosService } from 'app/servicios/parametros.service';
import { execDbService } from 'app/servicios/exec-db.service';

declare var $: any;

@Component({
  selector: "app-cargos-detalles",
  templateUrl: "./cargos-detalles.component.html",
  styleUrls: ["./cargos-detalles.component.css"],
})
export class CargosDetallesComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  @Input("cargosDetallesInput") cargosDetallesInput: CargosDetallesInput;
  @Output("cargosDetallesOutput") cargosDetallesOutput: EventEmitter<CargosDetallesInput>;
  @Output("totalAdeudoOutput") totalAdeudoOutput: EventEmitter<number>;
  @Output("totalAnomalisOutput") totalAnomalisOutput: EventEmitter<number>;
  @Input() bloquearCheck: boolean = false;
  @Input() tipoCargos: boolean = false;
  @Input() esAbono: boolean = false;
  @Input() esCaja: boolean = false;
  @Input("flagEdicion") flagEdicion: boolean = false;
  @Input("flagEstadoAdeudos") flagEstadoAdeudos: boolean = false;

  @Input("flagPrescripcion") flagPrescripcion: boolean = false;
  selectedestatus: any = [];

  cargosDetallesTable: CargosDetalles[];
  cargosDetallesTableServicios: CargosDetalles[];
  descuentosTable: Descuentos[];
  catUsuario: CatUsuarios;
  public total: number = 0;
  public noAnomalias: number = 0;
  selectedAll: any;
  buscando: boolean = false;
  columnasTabla: any[];
  headerRows: any[];
  colsHeaderDet: any[];
  cargosDetallesRequest: CargosDetallesRequest;
  public registroBitacora = new RegistroBitacoraInput();
  Motivo: string = "";
  //cols: any[];
  imageDialog: boolean = false;

  totalPeriodosUnicos: number = 0;
  contPeriodo: boolean = false;

  imagenes: any[] | undefined;
  estimadoAnual: boolean = false;
  soloVigente: boolean = false;
  activoEstimadoAnual: boolean = false;

  con_Convenio: boolean = true;
  con_Cargo: boolean = true;
  //clonedCargos: { [s: string]: CargosDetalles } = {};
  clonedCargos: CargosDetalles[];

  clonedCargosPres: CargosDetalles[];

  catEstatus: SelectItem[];
  selectIni: any = [];
  selectFin: any = [];
  selectedIni: any = [];
  selectedFin: any = [];
  rptHabilitado: boolean = false;
  flagPreCalculo: boolean = false;

  public idAgua: any;
  public totalFacturar: number;
  public total1: number;
  public idCargo: number;
  public auxJasper: AuxJasper;

  parametros: Parametros[] = [];
  selectedParametro: any; // Guarda el objeto seleccionado

  @Input("historico_adeudos") historico_adeudos: boolean = false;
  @Output() usuarioSeleccionado = new EventEmitter();
  @ViewChild('observaciones') observaciones: ElementRef;
  mostrarDialogoAutorizacion: boolean = false;

  display: boolean = false;
  flagTablaCargosServicios: boolean = false;
  currentRoute: string;
  columnasDescuentos = [
    { field: "fijar", header: "Fijar", ordenar: false, styleHeader: "width: 70px;", },
    { field: "operacion", header: "Editar", ordenar: false, styleHeader: "width: 70px;", },
    { field: "descripcion", header: "DEscripcion", styleHeader: "width: 350px;" },
    { field: "monto", header: "Monto", styleHeader: "width: 150px;" },
  ];
  ingresoPor = new IngresoPor();

  showDialog() {
    this.display = true;
  }
  changedFields = [];

  aplicaEstimadoAnual: boolean = false;

  constructor(
      private cargosDetallesService: CargosDetallesService,
      private muestraImageneservice: MuestraImageneservice,
      private CatEstatusService: CatEstatusService,
      private confirmationService: ConfirmationService,
      private router: Router,
      private registroBitacoraService: RegistroBitacoraService,
      private aguasService: AguasService,
      private padObservacionesService: PadObservacionesService,
      private route: ActivatedRoute,
      private authenticationService: AuthenticationService,
      private parametrosService: ParametrosService,
      private execDbService: execDbService,
    ) {
    this.cargosDetallesOutput = new EventEmitter();
    this.totalAdeudoOutput = new EventEmitter();
    this.totalAnomalisOutput = new EventEmitter();
    this.currentRoute = this.route.snapshot.url.map(segment => segment.path).join('/');
    this.cargosDetallesRequest = new CargosDetallesRequest();
    
  }



  async ngOnInit() {



    this.ingresoPor.Prescripcion = (this.currentRoute === "prescripcion");
    this.ingresoPor.caja = (this.currentRoute === "caja");
    this.ingresoPor.convenios = (this.currentRoute === "convenios");
    this.ingresoPor.editarCargo = (this.currentRoute === "edicion-cargo");
    this.ingresoPor.estadoCuenta = (this.currentRoute === "estadocuenta" && !this.historico_adeudos);  // Ya que el historico esta en la misma ruta de estado de cuenta, se tiene que hacer esta validacion.
    this.ingresoPor.historicoAdeudo = (this.historico_adeudos);


    // ===============================================================
    //Opciones de la tabla
    // ==============================================================

    this.columnasTabla = [
      
      { field: "Checkbox", header: "", styleHeader: "width: 30px;", incluir: true },
      { field: "imagenes", styleHeader: "width: 40px;", incluir: true },
      { field: "fechaCobro", styleHeader: "width: 150px;", incluir: true },
      { field: "fechaDeposito", styleHeader: "width: 150px;", incluir: true },
      { field: "cajero", header: "", styleHeader: "width: 150px;", incluir: true },
      { field: "caja", header: "", styleHeader: "width: 100px;", incluir: true },
      { field: "folio", header: "", styleHeader: "width: 100px;", incluir: true },
      { field: "medio", header: "", styleHeader: "width: 100px;", incluir: true },
      { field: "fijar", header: "fijar", styleHeader: "width: 70px;", incluir: true },
      { field: "edicion", header: "", styleHeader: "width: 100px;", incluir: true },
      { field: "estatus", header: "", styleHeader: "width: 100px;", incluir: true },
     // { field: "observaciones", header: "", styleHeader: "width: 200px;", incluir: true },
      { field: "estatusEdicion", header: "", styleHeader: "width: 100px;", incluir: true },
      { field: "fechaVencimiento", header: "", styleHeader: "width: 100px;", incluir: true },
      { field: "acumulado", styleHeader: "width: 100px;", incluir: true },
      { field: "totalFacturado", styleHeader: "width: 100px;", incluir: true },
      { field: "total", styleHeader: "width: 100px;", incluir: true },
      { field: "anio", styleHeader: "width: 90px;", incluir: true },
      { field: "lecturaIni", styleHeader: "width: 70px;", incluir: true },
      { field: "lecturaFin", styleHeader: "width: 70px;", incluir: true },
      { field: "consumos", styleHeader: "width: 60px;", incluir: true },
      { field: "consumosEdicion", styleHeader: "width: 60px;", incluir: true },
      { field: "anomalia", styleHeader: "width: 110px;", incluir: true },
      { field: "validacion", styleHeader: "width: 90px;", incluir: true },
      { field: "tarifa", styleHeader: "width: 70px;", incluir: true },
      { field: "fechaLectura", styleHeader: "width: 90px;", incluir: true },
      { field: "fechafacturacion", styleHeader: "width: 90px;", incluir: true },
      { field: "base", styleHeader: "width: 90px;", incluir: true },
      { field: "baseEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "baseIva", styleHeader: "width: 90px;", incluir: true },
      { field: "baseIvaEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "drenaje", styleHeader: "width: 90px;", incluir: true },
      { field: "drenajeEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "drenajeIva", styleHeader: "width: 90px;", incluir: true },
      { field: "drenajeIvaEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "manejo", styleHeader: "width: 90px;", incluir: true },
      { field: "manejoEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "manejoIva", styleHeader: "width: 90px;", incluir: true },
      { field: "manejoIvaEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "infra", styleHeader: "width: 90px;", incluir: true },
      { field: "infraEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "infraIva", styleHeader: "width: 90px;", incluir: true },
      { field: "infraIvaEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "recargos", styleHeader: "width: 90px;", incluir: true },
      { field: "recargosEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "convenios", styleHeader: "width: 90px;", incluir: true },
      { field: "conveniosEdicion", styleHeader: "width: 90px;", incluir: true },
      { field: "interesCon", styleHeader: "width: 90px;", incluir: true },
      { field: "concepto", styleHeader: "width: 95px;", incluir: true },
      { field: "servicios", styleHeader: "width: 95px;", incluir: true },
      { field: "serviciosEdicion", styleHeader: "width: 95px;", incluir: true },
      { field: "serviciosIva", styleHeader: "width: 95px;", incluir: true },
      { field: "serviciosIvaEdicion", styleHeader: "width: 95px;", incluir: true },
      { field: "cargoPendiente", styleHeader: "width: 90px;", incluir: true },
      { field: "importe", styleHeader: "width: 100px;", incluir: true },
      { field: "descuento", header: "", styleHeader: "width: 100px;", incluir: true },
      { field: "observacionesCobro", headers: "", styleHeader: "width: 150px;", incluir: true, },
    ];

    if (!(this.ingresoPor.estadoCuenta || this.ingresoPor.editarCargo || this.ingresoPor.caja || this.ingresoPor.convenios)) this.excluir('Checkbox')

    if (!(this.ingresoPor.Prescripcion || this.ingresoPor.editarCargo)) this.excluir('edicion')
    
    if (!(this.ingresoPor.estadoCuenta || this.ingresoPor.editarCargo || this.ingresoPor.historicoAdeudo)) this.excluir('imagenes')

    if (!this.ingresoPor.editarCargo) this.excluir('fijar')
    if (!(this.ingresoPor.historicoAdeudo)) this.excluir('estatus')
    if (!(this.ingresoPor.Prescripcion)) this.excluir('estatusEdicion')
    if (!(this.ingresoPor.Prescripcion)) this.Motivo = "";
    //if (!(this.ingresoPor.Prescripcion)) this.excluir('observaciones')
    
    if (!this.ingresoPor.historicoAdeudo) this.excluir('fechaCobro')
    if (!this.ingresoPor.historicoAdeudo) this.excluir('cajero')
    if (!this.ingresoPor.historicoAdeudo) this.excluir('fechaDeposito')
  
      

    if (!this.ingresoPor.historicoAdeudo) this.excluir('caja')
    if (!this.ingresoPor.historicoAdeudo) this.excluir('folio')
    if (!this.ingresoPor.historicoAdeudo) this.excluir('medio')
    //if (!(this.ingresoPor.estadoCuenta)) this.excluir('fechaVencimiento')
    if (!(this.ingresoPor.estadoCuenta || this.ingresoPor.Prescripcion || this.ingresoPor.editarCargo || this.ingresoPor.caja)) this.excluir('acumulado')
    if (!(this.ingresoPor.estadoCuenta || this.ingresoPor.Prescripcion || this.ingresoPor.editarCargo || this.ingresoPor.caja)) this.excluir('totalFacturado')
    if (!(this.ingresoPor.estadoCuenta)) this.excluir('validacion')
    if (!(this.ingresoPor.estadoCuenta || this.ingresoPor.editarCargo  ) ) this.excluir('tarifa')
    if (!(this.ingresoPor.estadoCuenta)) this.excluir('fechaLectura')
    if (!(this.ingresoPor.estadoCuenta)) this.excluir('fechafacturacion')
    if (!(this.ingresoPor.historicoAdeudo)) this.excluir('observacionesCobro')

    if ((this.ingresoPor.editarCargo)) this.excluir('base')
    if (!(this.ingresoPor.editarCargo)) this.excluir('baseEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('baseIva')
    if (!(this.ingresoPor.editarCargo)) this.excluir('baseIvaEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('drenaje')
    if (!(this.ingresoPor.editarCargo)) this.excluir('drenajeEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('drenajeIva')
    if (!(this.ingresoPor.editarCargo)) this.excluir('drenajeIvaEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('manejo')
    if (!(this.ingresoPor.editarCargo)) this.excluir('manejoEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('manejoIva')
    if (!(this.ingresoPor.editarCargo)) this.excluir('manejoIvaEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('infra')
    if (!(this.ingresoPor.editarCargo)) this.excluir('infraEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('infraIva')
    if (!(this.ingresoPor.editarCargo)) this.excluir('infraIvaEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('recargos')
    if (!(this.ingresoPor.editarCargo)) this.excluir('recargosEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('consumos')
    if (!(this.ingresoPor.editarCargo)) this.excluir('consumosEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('convenios')
    if (!(this.ingresoPor.editarCargo)) this.excluir('conveniosEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('servicios')
    if (!(this.ingresoPor.editarCargo)) this.excluir('serviciosEdicion')
    if ((this.ingresoPor.editarCargo)) this.excluir('serviciosIva')
    if (!(this.ingresoPor.editarCargo)) this.excluir('serviciosIvaEdicion')

    this.columnasTabla = this.columnasTabla.filter(x => x.incluir === true);

    if (this.flagPrescripcion == true) await this.getAllCatEstatus();
    await this.getPersonaAutoriza();
    if (this.cargosDetallesTable && this.cargosDetallesTable.length > 0) { this.selectAll(); }

    this.verificarRuta();
    await this.consultaSiAunVigenteEstimadoAnual()
  }

  async cargaMotivo ()
  {
    try
    {
      if (this.cargosDetallesTable.length > 0 && this.cargosDetallesTable[0].idAgua) 
      {
        this.idAgua = this.cargosDetallesTable[0].idAgua; 
        const datoRetorno = await this.aguasService.getSingle(this.idAgua).toPromise(); 
        if(datoRetorno)
        {
          const jsonObject = JSON.parse(datoRetorno.dato);
          this.Motivo = jsonObject?.Motivo;
        }
      }
    }
    catch (e) {
      if (e.response) { throw { message: e.response.data, }; } else { throw e; }
    } finally {
      console.log("Paso por cargaMotivo");
      this.buscando = false;
    }
  }

  excluir(field: string) {
    const columna = this.columnasTabla.find(col => col.field === field);
    if (columna) columna.incluir = false;
  }

  ngOnChanges() {
    this.catUsuario = JSON.parse(localStorage.getItem('currentUser'));

    if (this.cargosDetallesInput) {
      this.cargosDetallesInput.idUsuarioGuardo = this.catUsuario.id;
      this.cargosDetallesInput.conEstimadoAnual = false;
      if (this.historico_adeudos) {
        this.cargosDetallesInput.ejecutaCalculo = false;
      } else {
        this.cargosDetallesInput.ejecutaCalculo = true;
      }
      this.cargosDetallesInput.borrarEstimado = true;
      this.cargosDetallesInput.conCargo = true;
      this.cargosDetallesInput.conConvenio = true;
      this.getCargosDetalles(this.cargosDetallesInput);

    }
  }

  cambioMasivoEstatus() {
    try {
      //validaciones

      if (Object.keys(this.selectedestatus).length == 0) {
        this.muestraMensaje.error("Asegurece de seleccionar un estatus", "top", "center");
        return;
      }
      else if (Object.keys(this.selectedIni).length == 0) {
        this.muestraMensaje.error("Asegurece de seleccionar el periodo de inicio", "top", "center");
        return;
      }
      else if (Object.keys(this.selectedFin).length == 0) {
        this.muestraMensaje.error("Asegurece de seleccionar el periodo de fin", "top", "center");
        return;
      }


      this.cargosDetallesTable.forEach(x => {

        if (x.anio >= this.selectedIni?.value && x.anio <= this.selectedFin?.value && x.periodoParcialidad <= this.selectedFin?.periodo && x.periodoParcialidad >= this.selectedIni?.periodo) {
          x.cambio = true;
          x.idEstatus = this.selectedestatus?.value;
          x.estatus = this.selectedestatus?.label;
        }

      });

    } catch (e) {
      if (e.response) { throw { message: e.response.data, }; } else { throw e; }
    } finally {
      console.log("Paso por cambioMasivoEstatus");
      this.buscando = false;
    }
  }

  limpiarMasivo() {
    this.selectedestatus = this.cargosDetallesTable = this.selectedIni = this.selectedFin = [];

    localStorage.removeItem("cargosDetallesTable");
  }

  ngAfterViewInit() { }

  // prettier-ignore
  async ejecutaEstimadoAnual(e) {
    var conEstimadoAnual = e.checked;
    this.cargosDetallesInput.conEstimadoAnual = conEstimadoAnual;
    this.cargosDetallesInput.borrarEstimado = !conEstimadoAnual;
    await this.getCargosDetalles(this.cargosDetallesInput);

    if (conEstimadoAnual) {
      this.selectedAll = true;
      this.selectAll();
    }
    this.activoEstimadoAnual = conEstimadoAnual;
    //await this.getCargosDetalles(this.cargosDetallesInput);
    this.rptHabilitado = true;

  }

  async ejecutaTodo(e) {
    var conTodo = e.checked;
    //false solo vigentes
    //true todo
    if (conTodo == true)
      this.cargosDetallesInput.idEstatus = null;
    else
      this.cargosDetallesInput.idEstatus = 1;

    await this.getCargosDetalles(this.cargosDetallesInput);
  }

  // prettier-ignore
  async conCargo(e) {
    var conCargo = e.checked;
    this.cargosDetallesInput.conCargo = conCargo;
    this.cargosDetallesInput.ejecutaCalculo = false;
    // this.cargosDetallesInput.borrarEstimado = !conCargo;
    await this.getCargosDetalles(this.cargosDetallesInput);
    this.cargosDetallesInput.ejecutaCalculo = true;
  }
  // prettier-ignore
  async conConvenio(e) {
    var conConvenio = e.checked;
    this.cargosDetallesInput.conConvenio = conConvenio;
    this.cargosDetallesInput.ejecutaCalculo = false;
    await this.getCargosDetalles(this.cargosDetallesInput);
    this.cargosDetallesInput.ejecutaCalculo = true;
  }


  // prettier-ignore
  async getCargosDetalles(cargosDetallesInput: CargosDetallesInput) {
    if (this.buscando) {
      return;
    }
    try {
      
      //buscamos si ya pago el pago anual
      await this.PagoAnual(cargosDetallesInput);
      this.buscando = true;

      //Buscamos si ya tiene una simulacion (Precalculo)
      if(this.flagEdicion){
        cargosDetallesInput.idEstatus = 3;
        const dt = await this.cargosDetallesService.getBusquedas(cargosDetallesInput).toPromise();
        this.cargosDetallesTable = dt;
        if (this.cargosDetallesTable.length === 0) {
          this.flagPreCalculo = false;
        }else{
          this.flagPreCalculo = true;
        }
      }
      if (this.flagEdicion && !this.flagPreCalculo) {        
          cargosDetallesInput.idEstatus = 1;
      }
      const datoRetorno = await this.cargosDetallesService.getBusquedas(cargosDetallesInput).toPromise();
      this.cargosDetallesTable = datoRetorno;
      if (this.cargosDetallesTable.length === 0) {
        this.muestraMensaje.warning("El contrato actual no tiene adeudos pendientes.", "top", "center");
      }

      
    //if ((this.ingresoPor.Prescripcion)) await this.cargaMotivo();

      this.contarPeriodos();
      if (this.cargosDetallesTable.find(x => x.validacionremul) != undefined) this.muestraMensaje.warning("Esta cuenta contiene cargos por reconexión y/o multas", "top", "center");


      if (this.cargosDetallesTable) {
        this.flagTablaCargosServicios = this.cargosDetallesTable.some(item => item.idServicios !== null);
      }

      this.selectedAll = true;  // Asegúrate de que todos los renglones se seleccionen
      this.selectAll();

      if (this.flagPrescripcion) {
        // Recuperar el objeto guardado en localStorage
        let objetoRecuperadoString = localStorage.getItem("cargosDetallesTable");
        // Convertir la cadena JSON de vuelta a un objeto
        if (objetoRecuperadoString) {
          let objetoRecuperado = JSON.parse(objetoRecuperadoString);
          objetoRecuperado.forEach(x => {
            if (!datoRetorno.some(w => w.idCargo === x.idCargo)) this.cargosDetallesTable.push(x);
          });
        }

        var auxPeriodos = [];
        //Guardamos los periodos de parcialidad
        this.cargosDetallesTable.forEach(w => {
          auxPeriodos.some(x => x.label === w.anio + "/" + w.periodoParcialidad) ? null : auxPeriodos.push({ label: w.anio + "/" + w.periodoParcialidad, value: w.anio, periodo: w.periodoParcialidad });
        });
        // Ordenar personas por nombre de manera ascendente
        auxPeriodos.sort((a, b) => a.label.localeCompare(b.label));

        this.selectFin = this.selectIni = auxPeriodos;

        this.cargosDetallesTable.sort((a, b) => {
          if (a.idAgua === b.idAgua) {
            // Si los idAgua son iguales, ordena por otra columna (por ejemplo, idElectricidad)
            return a.anio - b.anio;
          }
          // Si los idAgua son diferentes, ordena por idAgua
          return a.idAgua - b.idAgua;
        });



      }

      localStorage.setItem('totalABimestresOutput', Object.keys(this.cargosDetallesTable).length.toString());
      // localStorage.setItem('cargosDetallesTable', JSON.stringify(this.cargosDetallesTable));

      //for (var idx = 0, len = this.cargosDetallesTable.length; idx < len; ++idx) {
      //  this.cargosDetallesTable[idx].id = idx;
      //  this.clonedCargos[this.cargosDetallesTable[idx].id] = { ...this.cargosDetallesTable[idx], };
      //}
      this.clonedCargos = [...this.cargosDetallesTable];
      this.clonedCargosPres = JSON.parse(JSON.stringify(this.cargosDetallesTable));
      {//Se obtiene el total del adeudo
        let totalAdeudo = Math.max(...this.cargosDetallesTable.map((o) => o.acumulado), 0);
        this.totalAdeudoOutput.emit(totalAdeudo);
      }

      {// Se obtiene las anomalias
        const numero = Object.keys(datoRetorno);

        for (var i of numero) {
          if (this.cargosDetallesTable[i].anomalia != null && this.cargosDetallesTable[i].anomalia != "MEDIDOR NUEVO" && this.cargosDetallesTable[i].anomalia != "PROMEDIO") {
            this.noAnomalias = this.noAnomalias + 1;
          }
        }
        let noAnomalia = this.noAnomalias;
        this.totalAnomalisOutput.emit(noAnomalia);
      }


    } catch (e) {
      if (e.response) { throw { message: e.response.data, }; } else { throw e; }
    } finally {
      console.log("Paso por getCargosDetalles");
      this.buscando = false;
    }
  }


  
  // prettier-ignore
  async PagoAnual(cargosDetallesInput: CargosDetallesInput) {
    if (this.buscando) {
      return;
    }
    try {
      this.buscando = true;
      const datoRetorno = await this.cargosDetallesService.getPagoAnual(cargosDetallesInput).toPromise();
      if(Object.keys(datoRetorno).length > 0) this.rptHabilitado = true;
    } catch (e) {
      if (e.response) { throw { message: e.response.data, }; } else { throw e; }
    } finally {
      console.log("Paso por PagoAnual");
      this.buscando = false;
    }
  }
  

  //Bandera que se emplea a traves de la ruta para habilitar o deshabilitar elementos de htmlS
  verificarRuta(): void {
    const rutaActual = this.router.url;
    this.contPeriodo = (rutaActual === '/atencion/estadocuenta');
  }


  contarPeriodos(): void {

    if (this.contPeriodo) {
      if (!this.cargosDetallesTable) return;
      const periodosValidos = this.cargosDetallesTable.filter(w => w.anio && w.periodoParcialidad);
      // Utilizamos un conjunto (Set) para obtener los valores únicos de los periodos
      const periodosUnicos = new Set(periodosValidos.map(w => `${w.anio}/${w.periodoParcialidad}`));
      this.totalPeriodosUnicos = periodosUnicos.size;
    }
  }




  // prettier-ignore
  async aplicaReglaSeleccion(index: number, row: any) {
    if (this.estimadoAnual) {
      const selectDelAnioActual = (row.anio === (new Date()).getFullYear() && row.periodoParcialidad > 0);
      if (!selectDelAnioActual) {
        this.estimadoAnual = false;
        await this.ejecutaEstimadoAnual(false);
      }

    }

    this.total = 0;
    if (row.selected) {
      for (let x = index; 0 <= x; x--) {
        this.cargosDetallesTable[x].selected = true;
      }
    } else {
      for (let x = index; x < this.cargosDetallesTable.length; x++) {
        this.cargosDetallesTable[x].selected = false;
      }
    }

    this.total = Math.max(...this.cargosDetallesTable.filter((item) => item.selected).map((o) => o.acumulado), 0);
    this.cargosDetallesOutput.emit(this.cargosDetallesInput);
  }

  // prettier-ignore
  //   async aplicaReglaSeleccion(index: number, row: any) {
  //     row.selected = !row.selected;
  //     this.updateTotal();
  //     this.cargosDetallesOutput.emit(this.cargosDetallesInput);
  // }

  //   updateTotal() {
  //       this.total = this.cargosDetallesTable
  //           .filter(item => item.selected) 
  //           .reduce((acc, item) => acc + item.acumulado, 0);  
  //   }

  async selectAll() {

    if (this.selectedAll) {
      // Si `selectedAll` es true, selecciona todos los elementos
      for (const item of this.cargosDetallesTable) {
        item.selected = true;
      }
    } else {
      // Si `selectedAll` es false, deselecciona todos los elementos
      for (const item of this.cargosDetallesTable) {
        item.selected = false;
      }
    }

    if (this.esCaja == true) {
      return;
    }

    if (this.activoEstimadoAnual) {
      this.estimadoAnual = false;
      await this.ejecutaEstimadoAnual(this.estimadoAnual);
    }

    for (var i = 0; i < this.cargosDetallesTable.length; i++) {
      if (this.selectedAll) this.cargosDetallesTable[i].selected = true;
      else this.cargosDetallesTable[i].selected = false;
    }

    for (var i = 0; i < this.cargosDetallesTable.length; i++) {
      this.total = 0;
      if (this.cargosDetallesTable[i].selected) {
        for (let x = i; 0 <= x; x--) {
          this.cargosDetallesTable[x].selected = true;
        }
        this.total = Math.max(...this.cargosDetallesTable.map((o) => o.acumulado), 0);
      } else {
        for (let x = i; x < this.cargosDetallesTable.length; x++) {
          this.cargosDetallesTable[x].selected = false;
        }

        this.total = 0;
      }
    }
    this.cargosDetallesOutput.emit(this.cargosDetallesInput);

  }

  aplicaFijar(index: number, row: any) {
    let catCargoEdit = row;
    this.clonedCargos[catCargoEdit.id] = { ...catCargoEdit };
    catCargoEdit.cambio = true;
  }
  onEditInit(event) {
    if(this.flagEdicion){
      let catCargoEdit = event.data;
      this.clonedCargos[catCargoEdit.id] = { ...catCargoEdit };
      catCargoEdit.cambio = true;
    }
  }
  onEditCancel(event) {
    let catCargoEdit = event.data;
    let index = this.cargosDetallesTable.findIndex(
      (obj) => obj.id === catCargoEdit.id);
    this.cargosDetallesTable[index] = { ...this.clonedCargos[catCargoEdit.id] };
  }

  async onEditComplete(event) {
    try {
    
      let catCargoEdit = event.data;
      const originalData = this.clonedCargos[catCargoEdit.id];
      if(this.flagEdicion){        
        if (!catCargoEdit.cambio) {
          if (catCargoEdit.base === this.clonedCargos[catCargoEdit.id].base
            && catCargoEdit.baseIva === this.clonedCargos[catCargoEdit.id].baseIva
            && catCargoEdit.drenaje === this.clonedCargos[catCargoEdit.id].drenaje
            && catCargoEdit.drenajeIva === this.clonedCargos[catCargoEdit.id].drenajeIva
            && catCargoEdit.manejo === this.clonedCargos[catCargoEdit.id].manejo
            && catCargoEdit.manejoIva === this.clonedCargos[catCargoEdit.id].manejoIva
            && catCargoEdit.infra === this.clonedCargos[catCargoEdit.id].infra
            && catCargoEdit.infraIva === this.clonedCargos[catCargoEdit.id].infraIva
            && catCargoEdit.recargos === this.clonedCargos[catCargoEdit.id].recargos
            && catCargoEdit.convenios === this.clonedCargos[catCargoEdit.id].convenios
            // && catCargoEdit.multa === this.clonedCargos[catCargoEdit.id].multa
            // && catCargoEdit.gasto === this.clonedCargos[catCargoEdit.id].gasto

            && catCargoEdit.Fijar === this.clonedCargos[catCargoEdit.id].Fijar
            && catCargoEdit.idEstatus === this.clonedCargos[catCargoEdit.id].idEstatus) {
            let index = this.cargosDetallesTable.findIndex((obj) => obj.id === catCargoEdit.id);
            this.cargosDetallesTable[index] = { ...this.clonedCargos[catCargoEdit.id] };
            return;
          }
          catCargoEdit.cambio = true;
        } else {
          // Compara cada campo y registra cambios
          if (catCargoEdit.base !== originalData.base) {
            this.changedFields.push(`Agua Monto: de ${originalData.base} a ${catCargoEdit.base}`);
          }
          if (catCargoEdit.baseIva !== originalData.baseIva) {
            this.changedFields.push(`Agua IVA: de ${originalData.baseIva} a ${catCargoEdit.baseIva}`);
          }
          if (catCargoEdit.drenaje !== originalData.drenaje) {
            this.changedFields.push(`Alcantarillado Monto: de ${originalData.drenaje} a ${catCargoEdit.drenaje}`);
          }
          if (catCargoEdit.drenajeIva !== originalData.drenajeIva) {
            this.changedFields.push(`Alcantarillado IVA: de ${originalData.drenajeIva} a ${catCargoEdit.drenajeIva}`);
          }
          if (catCargoEdit.manejo !== originalData.manejo) {
            this.changedFields.push(`Saneamiento Monto: de ${originalData.manejo} a ${catCargoEdit.manejo}`);
          }
          if (catCargoEdit.manejoIva !== originalData.manejoIva) {
            this.changedFields.push(`Saneamiento IVA: de ${originalData.manejoIva} a ${catCargoEdit.manejoIva}`);
          }
          if (catCargoEdit.infra !== originalData.infra) {
            this.changedFields.push(`Infra Monto: de ${originalData.infra} a ${catCargoEdit.infra}`);
          }
          if (catCargoEdit.infraIva !== originalData.infraIva) {
            this.changedFields.push(`Infra IVA: de ${originalData.infraIva} a ${catCargoEdit.infraIva}`);
          }
          if (catCargoEdit.recargos !== originalData.recargos) {
            this.changedFields.push(`Recargos: de ${originalData.recargos} a ${catCargoEdit.recargos}`);
          }
          if (catCargoEdit.convenios !== originalData.convenios) {
            this.changedFields.push(`Convenios Otros: de ${originalData.convenios} a ${catCargoEdit.convenios}`);
          }
          if (catCargoEdit.servicios !== originalData.servicios) {
            this.changedFields.push(`Cuentas Adicionales Monto: de ${originalData.servicios} a ${catCargoEdit.servicios}`);
          }
          if (catCargoEdit.serviciosIva !== originalData.serviciosIva) {
            this.changedFields.push(`Cuentas Adicionales Iva : de ${originalData.serviciosIva} a ${catCargoEdit.serviciosIva}`);
          }
          if (this.changedFields.length > 0) {
              this.changedFields.unshift(`Periodo año/mes  ${originalData.anio } mes ${catCargoEdit.periodoParcialidad}`);
          }
          
        }
      }
      
      // catUsuariosEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  async handleClick() {
      if (this.flagPreCalculo) {
         this.mostrarDialogoAutorizacion = true;
        //await this.ImprimeAcuse();  // Si es true, imprime acuse
      } else {
        await this.clonaCargos();   // Si es false, clona cargos
      }
  }
  
  async clonaCargos(){
    try{
      
      this.buscando = true;
     
      this.cargosDetallesRequest.cargosDetalles = this.cargosDetallesTable;
      this.cargosDetallesRequest.bitacora = null;
      this.cargosDetallesRequest.flagPreCalculo = this.flagPreCalculo;
      this.cargosDetallesTable
      await this.cargosDetallesService.clonaCargos(this.cargosDetallesRequest).toPromise();
      //this.flagPreCalculo = true;
      this.buscando = false;

      await this.getCargosDetalles(this.cargosDetallesInput);

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por clonaCargos");
      this.buscando = false;
    }
  }

  async criterioValidacion(){
    try{
      
      this.buscando = true;
     
      this.cargosDetallesRequest.cargosDetalles = this.cargosDetallesTable;
      this.cargosDetallesRequest.bitacora = null;
      this.cargosDetallesRequest.flagPreCalculo = this.flagPreCalculo;
      this.cargosDetallesTable
      //await this.cargosDetallesService.criterioValidacion(this.cargosDetallesRequest).toPromise();
      //this.flagPreCalculo = true;
      this.buscando = false;

      await this.getCargosDetalles(this.cargosDetallesInput);

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por clonaCargos");
      this.buscando = false;
    }
  }


  async guardarCambioCargoDetalle() {
    try {

      let lstCargosModificados = this.cargosDetallesTable.filter(x => x.cambio);
      this.idAgua = this.cargosDetallesTable[0].idAgua
      this.totalFacturar = this.cargosDetallesTable[0].totalFacturado;
      this.total1 = this.cargosDetallesTable[0].total;
      this.idCargo = this.cargosDetallesTable[0].idCargo;
      /*if (lstCargosModificados.length === 0) {
        this.muestraMensaje.warning("No se encontraron cambios", "top", "center");
        return;
      }*/

      if (this.flagEdicion) {
        this.flagPreCalculo;
        await this.guardar(lstCargosModificados);
        return;
      }
      if(this.flagPrescripcion){
  
        // Validar si algún id_estatus cambió
        const cambios = this.cargosDetallesTable.some((cargo, index) => 
            this.clonedCargosPres[index] && cargo.idEstatus !== this.clonedCargosPres[index].idEstatus
        );
        if (!cambios) {
          this.muestraMensaje.warning("No se encontraron cambios", "top", "center");
          return;
        }

        lstCargosModificados = this.cargosDetallesTable.filter((cargo, index) => 
            this.clonedCargosPres[index] && cargo.idEstatus !== this.clonedCargosPres[index].idEstatus
        );
      

        await this.confirmationService.confirm({
          message: '¿Estás seguro que quieres prescribir los periodos ? <br>' +
            lstCargosModificados
              .map(cargo => {
                let detalle = `${cargo.anio}/${cargo.periodoParcialidad}`;
                if (cargo.concepto && cargo.concepto.trim() !== '') {
                  detalle += ` - ${cargo.concepto}`;
                }
                return detalle;
              })
              .join('<br>') + '',
          header: 'Confirmación',
          icon: 'pi pi-info-circle',
          accept: async () => {
            await this.guardar(lstCargosModificados);
          },
          reject: () => {
            return;
          },
          acceptLabel: "Si"
        });

      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCambioCargoDetalle");
      this.buscando = false;
    }
  }

  async guardar(lstCargosModificados) {
    try {
      this.buscando = true;
      const bitacora=this.changedFields.join(", ");
      
      this.cargosDetallesRequest.cargosDetalles = lstCargosModificados;
      this.cargosDetallesRequest.bitacora = bitacora;
      
      this.cargosDetallesRequest.flagPreCalculo = this.flagPreCalculo;
      if(this.flagPrescripcion){
        this.cargosDetallesRequest.flagPreCalculo = null;
      }
      await this.cargosDetallesService.updateCargos(this.cargosDetallesRequest).toPromise();

      this.cargosDetallesTable.filter(x => x.cambio = false);
      this.buscando = false;
      await this.getCargosDetalles(this.cargosDetallesInput);
      this.muestraMensaje.notification("Cambios guardados", "top", "center");
      
      if(this.flagPrescripcion){
        //guardamos motvio en el json de aguas
        let aux = new PadObservaciones();
        aux.idAgua = this.idAgua;
        aux.observacion = this.Motivo;  
        await this.padObservacionesService.add(aux).toPromise();
     }
    

      //if(!this.observaciones) return; // (MAHERO) Si no existe este objeto, se sale de la funcion. Se puso esta validacion porque en la edicion de cargos estaba generando error. Ademas en donde si aplique esta observaciones, mas bien se debiera de guardar desde la funcion que esta guardando, no desde el front.
  
      //MAHERO) El registro en bitacora se debio de hacer desde la funcion  y no desde el front, pero ya que no mandaron los parametros necesarios, y que lo implementaron en esta parte, se agrega parche.
      this.registroBitacora.idAgua = this.idAgua;    
      debugger;  
      if (this.flagPrescripcion) { 
        debugger;
        var movimiento = lstCargosModificados
        .map(cargo => {
          let detalle = `${cargo.anio}/${cargo.periodoParcialidad}`;
          if (cargo.concepto && cargo.concepto.trim() !== '') {
            detalle += ` - ${cargo.concepto}`;
          }
          return detalle;
        })
        .join('<br>') + '';
        this.registroBitacora.accion ="OBSERVACION: " + this.Motivo; //(this.observaciones.nativeElement.value != null ? this.observaciones.nativeElement.value : "");
        this.registroBitacora.idConcepto = 1351;
        this.registroBitacora.movimiento = movimiento
        //await this.registroBitacoraService.add(this.registroBitacora).toPromise();
      } 


    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCambioCargoDetalle");
      this.buscando = false;
    }
  }
  async AplicarPreCalculo() {
    try {
      //validaciones
      if (this.Motivo.trim().length === 0) {
        this.muestraMensaje.warning("Ingrese un Motivo.", "top", "center");
        return;
      }

      //let lstCargosModificados = this.cargosDetallesTable.filter(x => x.cambio);
      
      this.idAgua = this.cargosDetallesTable[0].idAgua
      this.cargosDetallesRequest.cargosDetalles = this.cargosDetallesTable;
      this.cargosDetallesRequest.flagPreCalculo = this.flagPreCalculo;
      
      await this.cargosDetallesService.aplicaPreCalculo(this.cargosDetallesRequest).toPromise();

      this.Motivo = "";
      this.muestraMensaje.notification("Cambios guardados", "top", "center");

      await this.getCargosDetalles(this.cargosDetallesInput);

    } catch (e) {
      throw e;
    } finally {
      console.log("Paso por AplicarPreCalculo");
    }
  }

  async getAllCatEstatus() {
    try {
      const datoRetorno = await this.CatEstatusService.getAll().toPromise();
      this.catEstatus = datoRetorno.filter(x => this.soloPago(x)).map((datos) => {
        if (datos.id === 4) {
          datos.descripcion = "PRESCRITO";
        }
        return { label: datos.descripcion, value: datos.id };
      });

      // this.catEstatus = datoRetorno
      // this.catEstatus.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }
  async getPersonaAutoriza() {
    try {
      const datoRetorno = await this.parametrosService.getPersonaAutoriza().toPromise();
      this.parametros = datoRetorno;

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPersonaAutoriza");
    }
  }
  soloPago(catEstatus) {
    if (catEstatus.id == 1 || catEstatus.id == 4)
      return catEstatus;
  }
  cambiaDescripcion(ri, cargoDetalle) {
    let cargo = cargoDetalle;
    cargo.estatus = this.catEstatus.filter(x => x.value == ri.value)[0].label;
  }
  // CERR || 20240418 || se agrega metodo para activar tabla para editar desglose de descargos
  async abrirDialogoConTabla(row: any) {
    try {
      // Verificar si 'descuentosJson' está definido en 'row'
      if (row.descuentosJson) {
        // Parsear el JSON y agregarlo a 'descuentosTable'
        this.descuentosTable = [];
        const obj = await JSON.parse(row.descuentosJson);

        obj.forEach(x => {
          //const monto = parseFloat(x.monto.replace(/[^\d.-]/g, ''));
          if (isNaN(x.monto)) {
            const monto = parseFloat(x.monto.replace(/[^\d.-]/g, ''));
            x.monto = monto;

          }
          this.descuentosTable.push(x);
        })
      }
      this.showDialog();
    } catch (error) {
      throw error;
    }
  }
  async calcularValoresByBase(row: CargosDetalles) {
    try{
      if(row.baseIva != 0){
        row.baseIva = row.base * 0.16;
      }
      if(row.base != 0){

        // Solo calcular si ya tenían un monto asignado y no eran 0
        row.drenaje = row.drenaje != 0 ? row.base * 0.25 : 0;
        row.drenajeIva = row.drenaje != 0 ? row.drenaje * 0.16 : 0;

        row.manejo = row.manejo != 0 ? row.base * 0.10 : 0;
        row.manejoIva = row.manejo != 0 ? row.manejo * 0.16 : 0;

        row.infra = row.infra != 0 ? row.base * 0.05 : 0;
        row.infraIva = row.infra != 0 ? row.infra * 0.16 : 0;
      }     

    }catch(e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por calcularValoresByBase");
    }
  }
  // CERR || 20240422 || Se agrega metodo para guardar los descuentos
  async guardarCambioCargoDescuentos() {
    try {
      this.cargosDetallesTable.find(x => x.idCargo === this.descuentosTable[0].id_cargo).descuentosJson = JSON.stringify(this.descuentosTable);
      this.cargosDetallesTable.find(x => x.idCargo === this.descuentosTable[0].id_cargo).descuento = this.descuentosTable.reduce((acumulador, objeto) => acumulador + objeto.monto, 0);


      this.display = false


    } catch (error) {
      throw error;
    }
  }
  async muestraImagenes(renglon) {
    try {
      this.buscando = this.imageDialog = true;

      const datoRetorno = await this.muestraImageneservice
        .getSingle(renglon?.cuentaAgua, renglon?.periodoParcialidad, renglon?.anio.toString())
        .toPromise();

      if (datoRetorno == null) {
        this.muestraMensaje.error("No se encontraron imagenes.", "top", "center");
        this.imageDialog = false;
      }
      else {
        this.imagenes = datoRetorno;
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por muestraImagenes");
      this.buscando = false;
    }
  }
  async reportePagoAnual(){
      try {
        this.display=true;   
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "028_Pago_anual_anticipado";
        this.auxJasper.JasperReport.tipo = "pdf";

        let _id_agua = new ParametroJasper();
        _id_agua.nombre = "_id_agua";
        _id_agua.valor = this.cargosDetallesInput.idAgua + "";
        this.auxJasper.ParametroJasper.push(_id_agua);

            
    } catch (error) {
        console.error("Error al preparar el informe:", error);
        alert("No se pudo preparar el informe debido a un error.");
    } finally {
        console.log("Paso por imprimirReportePagoAnual");

    }
  }
  async ImprimeAcuse(){
      try {
        this.display=true; 
        this.mostrarDialogoAutorizacion = false;

        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "046_ajuste_cargo_consumo";
        this.auxJasper.JasperReport.tipo = "pdf";

        // Crear un array de ParametroJasper
      let parametros: ParametroJasper[] = [];

      // Crear cada parámetro con su respectiva instancia
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.cargosDetallesInput.idAgua.toString();
      parametros.push(_id_agua);

      let _id_usuario = new ParametroJasper();
      _id_usuario.nombre = "_id_usuario";
      _id_usuario.valor = this.authenticationService.currentUserValue.id.toString(); 
      parametros.push(_id_usuario);

      let _par_autoriza = new ParametroJasper();
      _par_autoriza.nombre = "_par_autoriza";
      _par_autoriza.valor = this.selectedParametro?.parametro || ''; // Obtiene el valor seleccionado
      parametros.push(_par_autoriza);
      

      let _observacion = new ParametroJasper();
      _observacion.nombre = "_observacion";
      _observacion.valor = this.Motivo.toString();
      parametros.push(_observacion);

      this.auxJasper.ParametroJasper = parametros;

            
    } catch (error) {
        console.error("Error al preparar el informe:", error);
        alert("No se pudo preparar el informe debido a un error.");
    } finally {
        console.log("Paso por imprimirImprimeAcuse");

    }
  } 
  async ImprimeAcusePrescripcion(){
    try {

      // Validar si algún id_estatus cambió
      const cambios = this.cargosDetallesTable.some((cargo, index) => 
          this.clonedCargosPres[index] && cargo.idEstatus !== this.clonedCargosPres[index].idEstatus
      );
      
      if (!cambios) {
        this.muestraMensaje.warning("No se encontraron cambios", "top", "center");
        this.mostrarDialogoAutorizacion = false;
        return;
      }

      this.mostrarDialogoAutorizacion = false;



      // Sumar el importe solo de los registros vigentes (idEstatus === 1)
      const importeModificado = parseFloat(
        this.cargosDetallesTable
          .filter(cargo => cargo.idEstatus === 1)
          .reduce((total, cargo) => total + cargo.importe, 0)
          .toFixed(2)  // Fija 2 decimales y convierte a string
      );  // Convierte el string de vuelta a número
      
      const importeOriginal = parseFloat(
        this.clonedCargosPres
          .filter(cargo => cargo.idEstatus === 1)
          .reduce((total, cargo) => total + cargo.importe, 0)
          .toFixed(2)
      );


      this.display=true;   
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "047_acuse_prescripcion";
      this.auxJasper.JasperReport.tipo = "pdf";

      // Crear un array de ParametroJasper
      let parametros: ParametroJasper[] = [];

      // Crear cada parámetro con su respectiva instancia
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.cargosDetallesInput.idAgua.toString();
      parametros.push(_id_agua);

      let _id_usuario = new ParametroJasper();
      _id_usuario.nombre = "_id_usuario";
      _id_usuario.valor = this.authenticationService.currentUserValue.id.toString(); 
      parametros.push(_id_usuario);

      let _par_autoriza = new ParametroJasper();
      _par_autoriza.nombre = "_par_autoriza";
      _par_autoriza.valor = this.selectedParametro?.parametro || ''; // Obtiene el valor seleccionado
      parametros.push(_par_autoriza);
      
      let _observacion = new ParametroJasper();
      _observacion.nombre = "_observacion";
      _observacion.valor = this.Motivo.toString();
      parametros.push(_observacion);

      let _importe_modificado = new ParametroJasper();
      _importe_modificado.nombre = "_importe_modificado";
      _importe_modificado.valor = importeModificado.toString().replace('.', '_');
      parametros.push(_importe_modificado);

      let _importe_original = new ParametroJasper();
      _importe_original.nombre = "_importe_original";
      _importe_original.valor = importeOriginal.toString().replace('.', '_');
      parametros.push(_importe_original);

      this.auxJasper.ParametroJasper = parametros;      
            
    }
    catch (error) {
      console.error("Error al preparar el informe:", error);
      alert("No se pudo preparar el informe debido a un error.");
    } finally {
      console.log("Paso por imprimirImprimeAcusePrescripcion");

    }   
  }

  async consultaSiAunVigenteEstimadoAnual() {

    try {
      this.aplicaEstimadoAnual = false;
      const inputJson = { "id_operacion": 3, "parametro": 'ESTIMADO_ANUAL'};
      const datoRet = await this.execDbService.processJsonData(inputJson).toPromise();
      
      if(datoRet.data !== null){
        // Convertir la cadena JSON de vuelta a un objeto
        let objetoRecuperado =  datoRet.data[0];
        this.aplicaEstimadoAnual = objetoRecuperado.existe;
      }

      console.log("aplicaEstimadoAnual: ", this.aplicaEstimadoAnual);
     
    } catch (error) {
      console.error("Error al procesar el JSON:", error);
      this.muestraMensaje.error("Error al procesar el JSON", "top", "center");
    }
  }
}
